var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_vm._l((_vm.list),function(item,i){return _c('div',{key:i,on:{"contextmenu":_vm.show}},[_c('IntervalIOReportListMobItem',{attrs:{"item":item}})],1)}),_c('IOContextMenu',{attrs:{"showMenu":_vm.showMenu,"x":_vm.x,"y":_vm.y}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }